import React from 'react';

function DataPreviewModal({ show, onClose, title, columns, data, isLoading }) {
  if (!show) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content" style={{ borderRadius: '0.5rem', overflow: 'hidden' }}>
          <div
            className="modal-header text-white"
            style={{
              background: 'linear-gradient(45deg, rgb(19, 72, 156) 0%, rgba(19, 72, 156, 1) 100%)',
              padding: '0.35rem 0.75rem',
              border: 'none',
              flexShrink: 0,
            }}
          >
            <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
              <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                <i className="bi bi-eye me-2"></i>
                {title}
              </h6>
              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-link text-white p-0 mb-0"
                  onClick={onClose}
                  title="Fechar"
                  style={{ fontSize: '1rem', textDecoration: 'none' }}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="modal-body p-0">
            {isLoading ? (
              <div className="text-center p-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
                <p className="mt-2 mb-0">Carregando registros...</p>
              </div>
            ) : data && data.length > 0 ? (
              <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <table className="table table-hover table-striped table-sm small mb-0">
                  <thead className="table-secondary sticky-top">
                    <tr>
                      <th className="text-center" style={{ width: '40px' }}>#</th>
                      {columns.map(col => (
                        <th key={col.key}>{col.label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((row, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        {columns.map(col => (
                          <td key={col.key}>{row[col.key] ?? '-'}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center p-4">
                <i className="bi bi-inbox fs-1 text-muted"></i>
                <p className="mt-2 mb-0">Nenhum registro encontrado.</p>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={onClose}
            >
              <i className="bi bi-x-circle me-1"></i>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataPreviewModal;
